import React from "react";
import PropTypes from "prop-types";
import "./spinner.scss";

const Spinner = (props) => {
  return (
    <div className={!props.isModel ? "fallback-spinner" : undefined}>
      <div className="loading component-loader">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
    </div>
  );
};
export default Spinner;

Spinner.propTypes = {
  isModel: PropTypes.bool.isRequired,
};
